import ReleaseOfInformation from './ReleaseOfInformation';

export default ReleaseOfInformation;
